// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"blue-box-title-module--textWrapper--3VXD7","textBox":"blue-box-title-module--textBox--2omJr","toProjects":"blue-box-title-module--toProjects--2VWq8"};